import React from 'react';
import './ProductFlowDiagram.css';

function FlowArrow() {
  return (
    <span className="product-flow-arrow" aria-hidden="true">
      <svg viewBox="0 0 48 16" fill="none">
        <path d="M1 8h30.5" stroke="currentColor" strokeWidth="2.8" strokeLinecap="round" />
        <path d="M32 3.1 45.5 8 32 12.9Z" fill="currentColor" />
      </svg>
    </span>
  );
}

const ProductFlowDiagram = ({ title = 'How it works', steps = [] }) => {
  if (!steps.length) return null;

  return (
    <section className="product-flow" aria-label={title}>
      <div className="container">
        {title ? <h2 className="product-flow-title">{title}</h2> : null}
        <ol className="product-flow-track">
          {steps.map((step, index) => {
            const isLast = index === steps.length - 1;
            return (
              <li key={step.title} className="product-flow-item">
                <article className="product-flow-card">
                  <span className="product-flow-num">{index + 1}</span>
                  {step.icon ? (
                    <span className="product-flow-icon" aria-hidden="true">
                      {step.icon}
                    </span>
                  ) : null}
                  <p className="product-flow-label">{step.title}</p>
                </article>
                {!isLast ? <FlowArrow /> : null}
              </li>
            );
          })}
        </ol>
      </div>
    </section>
  );
};

export default ProductFlowDiagram;
